import { render, staticRenderFns } from "./OrgContactPopup.vue?vue&type=template&id=638e288e"
import script from "./OrgContactPopup.vue?vue&type=script&lang=js"
export * from "./OrgContactPopup.vue?vue&type=script&lang=js"
import style0 from "./OrgContactPopup.vue?vue&type=style&index=0&id=638e288e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports